import(/* webpackMode: "eager" */ "/vercel/path0/src/app/cookies/page.tsx");
